export const LOCALIZED_AUDIO_KEYS = Object.freeze([
  'welcome', 'startBet', 'countdown', 'sendCards', 'win',
  'betPlacedSuccess', 'insufficientBalance', 'noChipPlaced',
  ...Array.from({ length: 12 }, (_, index) => `result${index + 1}`)
]);

export function normalizeAudioLanguage(language) {
  const normalized = String(language || '').trim().toLowerCase().split('-')[0];
  return normalized || 'zh';
}

export function buildAudioSources(key, language = 'zh') {
  if (key === 'click') return ['/Audio/click.mp3'];
  if (key === 'tick') return ['/Audio/countdown-tick-modern.mp3'];
  if (!LOCALIZED_AUDIO_KEYS.includes(key)) return [];
  const lang = normalizeAudioLanguage(language);
  const sources = [`/Audio/i18n/${lang}/${key}.mp3`, `/Audio/i18n/${lang}/${key}.ogg`];
  if (lang !== 'en') sources.push(`/Audio/i18n/en/${key}.mp3`, `/Audio/i18n/en/${key}.ogg`);
  return sources;
}

export function countdownAudioKey(previous, next) {
  const before = Math.max(0, Number(previous) || 0);
  const current = Math.max(0, Number(next) || 0);
  if (current === 11 && before > 11) return 'countdown';
  if (current > 0 && current < 10 && current !== before) return 'tick';
  if (current <= 0 && before > 0) return 'sendCards';
  return '';
}

export function resultAudioKeys(resultCode, total = 0) {
  const code = Number.parseInt(resultCode, 10);
  if (code < 1 || code > 12) return [];
  return Number(total) > 0 ? [`result${code}`, 'win'] : [`result${code}`];
}
